/* eslint-disable default-param-last */
/* eslint-disable import/no-unresolved */
import { Reducer } from "redux";
import { bindAssignmentClauseApiData } from "src/helpers/FormDetails";
import { initialValues } from "src/helpers/FormDetails/AssignmentClause";
import {
  SAVE_ASSIGNMENT_CLAUSE_DETAILS,
  SET_ASSIGNMENT_CLAUSE_DETAILS
} from "src/redux/Types/assignmentClauseDetails";
import { IAssignmentClauseDetails } from "./interface";

const initialState: IAssignmentClauseDetails = {
  ...initialValues
};

const assignmentClauseDetailsReducer: Reducer<IAssignmentClauseDetails> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case SAVE_ASSIGNMENT_CLAUSE_DETAILS: {
      const data = bindAssignmentClauseApiData(
        action.payload?.apiData,
        action.payload?.address,
        action?.payload?.masterData
      );
      return { ...state, ...data };
    }
    case SET_ASSIGNMENT_CLAUSE_DETAILS: {
      return { ...state, ...action.payload };
    }
    default:
      return state;
  }
};

export default assignmentClauseDetailsReducer;
